import { CEAppliedConstraintAttributesBase } from './ce-applied-constraint-attributes-base'


export class CEAppliedConstraintAttributes extends CEAppliedConstraintAttributesBase {

}